export namespace AuthActions {
    export class SetToken {
        constructor(public token: string) { }
        static readonly type = '[Auth] Set Token'
    }

    export class DeleteToken {
        static readonly type = '[Auth] Delete Token'
    }
}